@for (attachment of attachments(); track attachment.id) {
    <tran-file-item
        [attachment]="attachment"
        [allowDownload]="allowDownload()"
        [allowDelete]="allowDelete()"
        [allowUndoDelete]="allowUndoDelete()"
        [askDelete]="askDelete()"
        (download)="download.emit($event)"
        (delete)="delete.emit($event)"
        (undoDelete)="undoDelete.emit($event)"
    />
}
<tran-load-more-files
    [canLoadMore]="hasMoreAttachments()"
    (loadMore)="loadMore.emit()"
    label="components.application-detail-dashboard.application-detail-attachments.load-more"
/>
